<script setup lang="ts">
import SiteSidebar from '@/layouts/partials/SiteSidebar.vue';
import ConfirmationDialogProvider from '@/layouts/partials/ConfirmationDialogProvider.vue';
import SiteHeader from '@/layouts/partials/SiteHeader.vue';
import FullPageLoader from '@/layouts/partials/FullPageLoader.vue';
import OverlayProvider from '@/components/OverlayProvider.vue';
import OfflineBanner from '@/components/OfflineBanner.vue';
import GlobalSearch from '@/components/GlobalSearch.vue';
import { useGlobalSearchShortcut } from '@/composables/useGlobalSearchShortcut';
import { Toaster } from '@/components/ui/sonner';
import { TooltipProvider } from '@/components/ui/tooltip';

useGlobalSearchShortcut();
</script>

<template>
    <TooltipProvider>
        <a
            href="#main-content"
            class="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-tooltip focus:rounded-md focus:bg-white focus:px-4 focus:py-2 focus:text-sm focus:font-semibold focus:text-gray-900 focus:shadow-md focus:outline-none focus:ring-2 focus:ring-primary-500"
        >
            Naar hoofdinhoud
        </a>

        <div class="flex grow">
            <SiteHeader />

            <SiteSidebar />

            <main
                id="main-content"
                tabindex="-1"
                class="relative z-0 flex min-w-0 grow flex-col bg-gray-50 pt-14 transition-all duration-500 ease-in-out focus:outline-none md:pt-16 lg:pl-56"
            >
                <Suspense>
                    <template #default>
                        <slot />
                    </template>
                    <template #fallback>
                        <FullPageLoader />
                    </template>
                </Suspense>
            </main>
        </div>

        <GlobalSearch />
        <Toaster />
        <ConfirmationDialogProvider />
        <OverlayProvider />
        <OfflineBanner />
    </TooltipProvider>
</template>
